import React from 'react';
import { BASE_API_URL } from '../apiConfig';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';

const SocialLogin = ({ setModalConfig }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleGoogleSuccess = async (tokenResponse) => {
        try {
            // Otteniamo i dati dell'utente usando l'access token
            const userInfoRes = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
                headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
            });
            const userData = await userInfoRes.json();

            // Inviamo i dati al nostro backend
            const res = await fetch(`${BASE_API_URL}/social-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    first_name: userData.given_name,
                    last_name: userData.family_name || '',
                    email: userData.email,
                    provider: 'google',
                    provider_id: userData.sub,
                    avatar_url: userData.picture
                })
            });

            const data = await res.json();
            if (res.ok) {
                localStorage.setItem('token', data.token);
                // Aggiorna l'oggetto 'user' per la persistenza
                localStorage.setItem('user', JSON.stringify({
                    ...data.user,
                    email: userData.email
                }));
                const redirectUrl = localStorage.getItem('redirectAfterLogin') || '/';
                localStorage.removeItem('redirectAfterLogin');
                navigate(redirectUrl);
            } else {
                setModalConfig({ isOpen: true, message: data.error || t('login_error') });
            }
        } catch (error) {
            console.error("Google Login Error:", error);
            setModalConfig({ isOpen: true, message: t('google_login_error') });
        }
    };

    const loginWithGoogle = useGoogleLogin({
        onSuccess: handleGoogleSuccess,
        onError: () => setModalConfig({ isOpen: true, message: t('google_login_failed') }),
    });

    /* 
                    <button 
                    type="button" 
                    className="social-btn facebook"
                    onClick={() => setModalConfig({ isOpen: true, message: t('facebook_integration_warning') })}
                >
                    <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg" alt="Facebook" />
                    Facebook
                </button>
    */
    return (
        <div className="social-login-container">
            <div className="social-divider">{t('or_continue_with')}</div>
            <div className="social-login">
                <button
                    type="button"
                    className="social-btn google"
                    onClick={() => loginWithGoogle()}
                >
                    <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" />
                    Google
                </button>
            </div>
        </div>
    );
};

export default SocialLogin;
